export default __webpack_public_path__ + "static/media/placeholder_business04-it-mobile.4d730cf0.png";